/** api集中管理 */
import Vue from 'vue'
const requireAll = require.context('@/service/apiService', true, /\.js$/)
const apiArr = requireAll.keys().map(apiName => requireAll(apiName).default || requireAll(apiName))
// 组合接口
const $api = apiArr.reduce((prev, curr) => Object.assign(prev, curr), {})
// 将所有请求方法批量挂载vue；
Vue.prototype.$api = $api
